import request from '../../axios';

export const patchDirectLoanRequest = async (
  payload: IPatchDirectLoanRequestPayload,
) => {
  const data = await request.patch(
    `api/v2/payment/direct-loan-request`,
    payload,
  );

  return data;
};
